const layout = {
    header: {
        company: 'Company',
        user: 'User',
        subtitle: 'Delivery in',
        buttonBack: 'Back',
        buttonCheckout: 'Checkout',
    },
    mobileMenu: {
        company: 'Company settings',
        user: 'My profile',
    },
    footer: {
        contractOffer: 'User agreement',
        privacyPolicy: 'Privacy policy',
        userAgreement: 'Terms of use',
        partnerWebsite: 'Aqua Delivery partner website',
        personalDataAgreement: 'Consent to personal data processing',
    },
    buttons: {
        logout: 'Sign out',
    },
};

export default layout;
